import { defineComponent, ref, computed, isVue3 } from 'vue-demi';
import { s as script$1 } from './OrLoader-b79022da.js';
import { resolveComponent, openBlock, createElementBlock, mergeProps, toHandlers, createElementVNode, normalizeClass, renderSlot, createBlock, Fragment, createTextVNode, toDisplayString, createCommentVNode } from 'vue';

var ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["Contained"] = "contained";
  ButtonVariant["Outlined"] = "outlined";
  ButtonVariant["Text"] = "text";
  ButtonVariant["Link"] = "link";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonColor;
(function (ButtonColor) {
  ButtonColor["Primary"] = "primary";
  ButtonColor["Danger"] = "danger";
  ButtonColor["Inherit"] = "inherit";
})(ButtonColor || (ButtonColor = {}));
var ButtonType;
(function (ButtonType) {
  ButtonType["Button"] = "button";
  ButtonType["Submit"] = "submit";
  ButtonType["Reset"] = "reset";
})(ButtonType || (ButtonType = {}));

const ButtonRoot = [
// Layout
'layout-inline-row justify-center',
// Shape
'rounded-md',
// Interactivity
'interactivity-auto',
// Typography
'typography-button'];
const ButtonRootVariants = {
  'contained': [
  // Box
  'min-w-[96px]',
  // Spacing
  'px-md md:px-md', 'py-sm+ md:py-sm', 'gap-sm+ md:gap-sm',
  // Theme
  'enabled:shadow-button', 'dark:enabled:shadow-button-dark'],
  'outlined': [
  // Box
  'min-w-[96px]',
  // Spacing
  'px-md* md:px-md*', 'py-sm+* md:py-sm*', 'gap-sm+ md:gap-sm'],
  'text': [
  // Box
  'min-w-[96px]',
  // Spacing
  'px-md md:px-md', 'py-sm+ md:py-sm', 'gap-sm+ md:gap-sm'],
  'link': [
  // Spacing
  'gap-xs']
};
const ButtonRootColors = {
  'primary-contained': [
  // Theme
  'theme-preset-1-primary', 'dark:theme-preset-1-primary-dark'],
  'danger-contained': [
  // Theme
  'theme-preset-1-error', 'dark:theme-preset-1-error-dark'],
  'inherit-contained': [],
  'primary-outlined': [
  // Theme
  'theme-preset-3-primary', 'dark:theme-preset-3-primary-dark', 'theme-border-1-outline', 'dark:theme-border-1-outline-dark',
  // Theme (active)
  'active:theme-border-1-primary', 'dark:active:theme-border-1-primary-dark'],
  'danger-outlined': [
  // Theme
  'theme-preset-3-error', 'dark:theme-preset-3-error-dark', 'theme-border-1-error', 'dark:theme-border-1-error-dark'],
  'inherit-outlined': [],
  'primary-text': [
  // Theme
  'theme-preset-4-primary', 'dark:theme-preset-4-primary-dark'],
  'danger-text': [
  // Theme
  'theme-preset-4-error', 'dark:theme-preset-4-error-dark'],
  'inherit-text': [
  // Theme
  'theme-foreground-inherit', 'dark:theme-foreground-inherit-dark'],
  'primary-link': [
  // Theme
  'theme-preset-4-primary', 'dark:theme-preset-4-primary-dark'],
  'danger-link': [
  // Theme
  'theme-preset-4-error', 'dark:theme-preset-4-error-dark'],
  'inherit-link': [
  // Theme
  'theme-foreground-inherit', 'dark:theme-foreground-inherit-dark',
  // Theme (activated)
  'activated:theme-foreground-default', 'dark:activated:theme-foreground-default-dark']
};

var script = defineComponent({
  name: 'OrButton',
  components: {
    OrLoader: script$1
  },
  props: {
    type: {
      type: String,
      default: ButtonType.Button
    },
    variant: {
      type: String,
      default: ButtonVariant.Contained
    },
    color: {
      type: String,
      default: ButtonColor.Primary
    },
    activated: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Loading'
    }
  },
  emits: ['click', 'focus', 'blur'],
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-button-v3', ...ButtonRoot, ...ButtonRootVariants[props.variant], ...ButtonRootColors[`${props.color}-${props.variant}`], props.loading && 'interactivity-none']);
    return {
      root,
      rootStyles,
      isVue3
    };
  }
});

const _hoisted_1 = ["type", "activated", "disabled"];
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/normalizeClass(['absolute'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLoader = resolveComponent("OrLoader");
  return openBlock(), createElementBlock("button", mergeProps({
    ref: "root",
    class: _ctx.rootStyles,
    type: _ctx.type,
    activated: _ctx.activated ? '' : null,
    disabled: _ctx.disabled
  }, toHandlers({
    ...(_ctx.isVue3 ? {} : _ctx.$listeners),
    click: e => _ctx.$emit('click', e),
    focus: e => _ctx.$emit('focus', e),
    blur: e => _ctx.$emit('blur', e)
  }, true)), [createElementVNode("div", {
    class: normalizeClass(['contents', _ctx.loading && 'invisible'])
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */), _ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_2, [_ctx.variant !== 'link' ? (openBlock(), createBlock(_component_OrLoader, {
    key: 0,
    variant: 'circular',
    color: 'inherit',
    size: 's'
  })) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [createTextVNode(toDisplayString(_ctx.loadingText) + "… ", 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */))])) : createCommentVNode("v-if", true)], 16 /* FULL_PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-button-v3/OrButton.vue";

export { ButtonVariant as B, ButtonColor as a, ButtonType as b, script as s };
